import { useState } from "react";
import {
  Container,
  Box,
  Typography,
  Button,
  Stack,
  Paper,
  Dialog,
  DialogTitle,
  DialogContent,
  TextField,
  DialogActions,
  CircularProgress,
  Modal
} from "@mui/material";
import { Add } from "@mui/icons-material";
import Logocolor from "../Image/Logo.png";
import { useSucursales, useGetSucursal } from "../Services/Sucursales";
import {
  Texto,
  buttonGuardar,
  Input,
  buttonCancelar,
  modalStyle,
  styleCarga,
  SubTitulodos
} from "../Layouts/CustomStyles";
import { FaTrashCan } from "react-icons/fa6";
import { IoClose } from "react-icons/io5";
import { BiErrorCircle } from "react-icons/bi";
import { FaRegCircleCheck } from "react-icons/fa6";

export const PaginaCentrosClinicos = () => {
  const { postSucursales, eliminarSucursal } = useSucursales();
  const { sucursales, loadings, refetch } = useGetSucursal();


  const [openCrear, setOpenCrear] = useState(false);
  const [openConfirm, setOpenConfirm] = useState(false);
  const [sucursalSeleccionada, setSucursalSeleccionada] = useState(null);
  const [loadingEliminar, setLoadingEliminar] = useState(false);

  const [nuevoCentro, setNuevoCentro] = useState({ name: "", address: "" });
  const [loading, setLoading] = useState(false);
  const [successAlertOpen, setSuccessAlertOpen] = useState(false);
  const [errorAlertOpen, setErrorAlertOpen] = useState(false);
  const [enviandoAlert, setEnviandoAlert] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");

  const handleChange = (e) => {
    setNuevoCentro({ ...nuevoCentro, [e.target.name]: e.target.value });
  };

  const handleCrear = async () => {
    if (!nuevoCentro.name.trim() || !nuevoCentro.address.trim()) return;
    setLoading(true);
    try {
      await postSucursales(nuevoCentro);
       await refetch();
      setNuevoCentro({ name: "", address: "" });
      setAlertMessage("Sucursal creada exitosamente.");
      setSuccessAlertOpen(true);
      setOpenCrear(false);
    } catch (err) {
      setAlertMessage("Error al crear sucursal.");
      setErrorAlertOpen(true);
    } finally {
      setLoading(false);
      setEnviandoAlert(false);
    }
  };

  // ✅ Abrir el diálogo de confirmación
  const handleOpenConfirm = (id) => {
    setSucursalSeleccionada(id);
    setOpenConfirm(true);
  };

  // ✅ Confirmar eliminación
  const handleEliminarConfirmado = async () => {
    setLoadingEliminar(true);
    try {
      await eliminarSucursal(sucursalSeleccionada);
       await refetch();
      setAlertMessage("Sucursal eliminada correctamente.");
      setSuccessAlertOpen(true);
    } catch (err) {
      console.error("Error al eliminar sucursal:", err);
      setAlertMessage("Error al eliminar sucursal.");
      setErrorAlertOpen(true);
    } finally {
      setLoadingEliminar(false);
      setOpenConfirm(false);
      setSucursalSeleccionada(null);
    }
  };

  if (loadings)
    return (
      <Box display="flex" justifyContent="center" mt={4} sx={styleCarga}>
        <CircularProgress />
      </Box>
    );

  return (
    <Container maxWidth="lg" sx={{ py: 5 }}>
      <Paper
        elevation={4}
        sx={{
          p: 4,
          borderRadius: "20px",
          background: "linear-gradient(145deg, #ffffff, #f4f6f8)",
          boxShadow: "0 10px 30px rgba(0,0,0,0.1)"
        }}
      >
        {/* Cabecera */}
        <Box
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          mb={4}
          flexWrap="wrap"
        >
          <Box display="flex" alignItems="center" gap={2}>
            <img
              src={Logocolor}
              alt="Logo Clínica Activa"
              style={{ width: 55, height: 55, objectFit: "contain" }}
            />
            <Typography variant="h5" sx={Texto}>
              Centros Alemana Activa
            </Typography>
          </Box>
          <Button
            variant="contained"
            startIcon={<Add />}
            sx={buttonGuardar}
            onClick={() => setOpenCrear(true)}
          >
            Crear centro clínico
          </Button>
        </Box>

        {/* Listado de sucursales */}
        <Stack spacing={2}>
          {sucursales?.map((s) => (
            <Paper
              key={s.id}
              sx={{
                p: 2,
                borderRadius: "12px",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center"
              }}
            >
              <Box>
                <Typography sx={Texto}>{s.name}</Typography>
                <Typography sx={{ color: "#666" }}>{s.address}</Typography>
              </Box>
              <button
                className="delete-button"
                onClick={() => handleOpenConfirm(s.id)}
              >
                <FaTrashCan className="delete-svgIcon" />
              </button>
            </Paper>
          ))}
        </Stack>

        {/* Dialog Crear Sucursal */}
        <Dialog open={openCrear} onClose={() => setOpenCrear(false)} fullWidth maxWidth="sm">
          <DialogTitle sx={Texto}>Crear nuevo centro clínico</DialogTitle>
          <DialogContent>
            <Stack spacing={2} sx={{ mt: 1 }}>
              <TextField
                sx={Input}
                label="Nombre del centro"
                name="name"
                value={nuevoCentro.name}
                onChange={handleChange}
                fullWidth
              />
              <TextField
                sx={Input}
                label="Dirección"
                name="address"
                value={nuevoCentro.address}
                onChange={handleChange}
                fullWidth
              />
            </Stack>
          </DialogContent>
          <DialogActions>
            <Button sx={buttonCancelar} onClick={() => setOpenCrear(false)}>
              Cancelar
            </Button>
            <Button
              variant="contained"
              sx={buttonGuardar}
              onClick={handleCrear}
              disabled={loading}
            >
              {loading ? <CircularProgress size={24} /> : "Guardar"}
            </Button>
          </DialogActions>
        </Dialog>

        {/* ✅ Dialog Confirmar Eliminación */}
        <Dialog open={openConfirm} onClose={() => setOpenConfirm(false)}>
          <DialogTitle sx={Texto}>¿Eliminar sucursal?</DialogTitle>
          <DialogContent>
            <Typography  sx={SubTitulodos}>
              ¿Seguro que deseas eliminar esta sucursal? Esta acción no se puede deshacer.
            </Typography>
          </DialogContent>
          <DialogActions>
            <Button sx={buttonGuardar} onClick={() => setOpenConfirm(false)}>
              Cancelar
            </Button>
            <Button
              sx={buttonCancelar}
              onClick={handleEliminarConfirmado}
              disabled={loadingEliminar}
            >
              {loadingEliminar ? <CircularProgress size={20} color="inherit" /> : "Eliminar"}
            </Button>
          </DialogActions>
        </Dialog>
      </Paper>

      {/* ✅ Modales de éxito y error */}
      <Modal open={successAlertOpen} onClose={() => setSuccessAlertOpen(false)}>
        <Box sx={modalStyle}>
          <section className="closemodal" onClick={() => setSuccessAlertOpen(false)}>
            <IoClose />
          </section>
          <section style={{ textAlign: "center" }}>
            <FaRegCircleCheck style={{ color: "green", fontSize: "2rem" }} />
            <p className="alert-text">{alertMessage}</p>
          </section>
        </Box>
      </Modal>

      <Modal open={errorAlertOpen} onClose={() => setErrorAlertOpen(false)}>
        <Box sx={modalStyle}>
          <section className="closemodal" onClick={() => setErrorAlertOpen(false)}>
            <IoClose />
          </section>
          <section style={{ textAlign: "center" }}>
            <BiErrorCircle style={{ color: "red", fontSize: "2rem" }} />
            <p className="alert-text">{alertMessage}</p>
          </section>
        </Box>
      </Modal>

      <Modal open={enviandoAlert}>
        <Box sx={modalStyle}>
          <section style={{ textAlign: "center", padding: "1rem" }}>
            <CircularProgress style={{ color: "#2a8d74" }} />
            <p className="alert-text">Procesando solicitud...</p>
          </section>
        </Box>
      </Modal>
    </Container>
  );
};
